import { render, staticRenderFns } from "./JobboardSpecForm.vue?vue&type=template&id=1485c136"
import script from "./JobboardSpecForm.vue?vue&type=script&lang=js"
export * from "./JobboardSpecForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports